import React from 'react';

import Container from './Components/Container/Container';

import './App.css';

function App() {
  return (
    <div className="App">
      <Container />
    </div>
  );
}

export default App;
